import { Component, EventEmitter, Input, Output, OnInit, Inject } from '@angular/core';
import {
    ApplicationFacade,
    StopRouteResult,
    AddressResult,
    PoiAddressResult,
    SearchUtil,
    MapIcons
} from '@ridango/components';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-search-item',
    templateUrl: './search-item.component.html',
    styleUrls: ['./search-item.component.scss']
})
export class SearchItemComponent implements OnInit {
    @Input() searchItem: StopRouteResult | AddressResult | PoiAddressResult;
    @Input() displayCode = true;
    @Input() searchText: string;
    @Output() select: EventEmitter<StopRouteResult | AddressResult | PoiAddressResult> = new EventEmitter<
        StopRouteResult | AddressResult | PoiAddressResult
    >();
    searchName: string;
    readonly searchUtil = SearchUtil;

    assetsPath$ = this.applicationFacade.assetsPath$;
    addressIcon = MapIcons('address', this.env.THEME_NAME);
    poiIcon = MapIcons('poi', this.env.THEME_NAME);

    constructor(
        private applicationFacade: ApplicationFacade,
        @Inject('ENV') public env: Env
    ) {}

    ngOnInit(): void {
        this.isPoiAddressResult();
    }

    isPoiAddressResult() {
        if (this.searchUtil.isPoiAddressResult(this.searchItem) && this.searchItem?.poi_name) {
            this.searchName = this.searchItem.poi_name;
        } else if (this.searchUtil.isAddressResult(this.searchItem) && this.searchItem?.address) {
            this.searchName = this.searchItem?.address;
        } else {
            this.searchName = this.searchItem.name;
        }
    }
}
